import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	font-family: 'Poppins', sans-serif;
	flex: ${({ flex }) => flex};
	width: ${({ width }) => width};
	height: ${({ height }) => height};
	align-items: ${({ align }) => align};
	justify-content: ${({ justify }) => justify};
	flex-direction: ${({ direction }) => direction};
	flex-wrap: ${({ wrap }) => wrap};
	margin: ${({ margin }) => margin};
	padding: ${({ padding }) => padding};
	border: ${({ border }) => border};
	border-radius: ${({ borderRadius }) => borderRadius};

	a:hover {
		text-decoration: none;
		color: inherit;
	}
`;
